<template>
  <div class="">
    <button class="btn-indigo w-32 font-normal" @click="openModal()">{{ newButton ? newButton = newButton : 'Add Task' }}</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Schedule Task
        </h1>
        <form id="taskForm" name="taskForm" @submit.prevent="saveTask">
          <div class="flex justify-between mb-6">
            <div class="container flex flex-col items-center">
              <div>
                <input v-model="taskForm.scheduleBy" type="radio" value="delay" />
              </div>
              <div class="font-bold">
                Schedule by Delay
              </div>
            </div>
            <div class="container flex flex-col items-center">
              <div>
                <input v-model="taskForm.scheduleBy" type="radio" value="date" />
              </div>
              <div class="font-bold">
                Schedule by Date
              </div>
            </div>
          </div>
          <div v-if="!hideScheduler" class="flex justify-between">
            <div>
              <select-input v-model="taskForm.delay_from" :error="taskForm.errors.delay_from" class="pr-6 pb-4 w-full" label="From">
                <option value="now">Now  </option>
                <option value="last">Last  </option>
              </select-input>
            </div>
            <div>
              <select-input v-model="taskForm.delay_minutes" :error="taskForm.errors.delay_minutes" class="pr-6 pb-4 w-full" label="Minutes">
                <option v-for="n in getNumbers(1,59,1)" :key="n" :value="n">{{ n }} Mins</option>
              </select-input>
            </div>
            <div>
              <select-input v-model="taskForm.delay_hours" :error="taskForm.errors.delay_hours" class="pr-6 pb-4 w-full" label="Hours">
                <option v-for="n in getNumbers(1,24,1)" :key="n" :value="n">{{ n }} Hours</option>
              </select-input>
            </div>
            <div>
              <select-input v-model="taskForm.delay_days" :error="taskForm.errors.delay_days" class="pr-6 pb-4 w-full" label="Days">
                <option v-for="n in getNumbers(1,24,1)" :key="n" :value="n">{{ n }} Days</option>
              </select-input>
            </div>
            <div>
              <select-input v-model="taskForm.delay_months" :error="taskForm.errors.delay_months" class="pr-6 pb-4 w-full" label="Months">
                <option v-for="n in getNumbers(1,12,1)" :key="n" :value="n">{{ n }} Months</option>
              </select-input>
            </div>
          </div>
          <div v-if="hideScheduler">
            <label class="form-label">Set Date and Time:</label>
            <Datepicker v-model="taskForm.trigger_time" class="mb-4 pr-6 w-full" :is-24="false" />
            <div v-if="taskForm.errors.trigger_time" class="form-error pb-4 w-full">{{ taskForm.errors.trigger_time }}</div>
          </div>
          <select-input v-model="taskForm.type" :error="taskForm.errors.type" class="pr-6 pb-4 w-full" label="Task Type">
            <option value="reminder">Reminder</option>
            <option value="email">Email</option>
            <option value="text">SMS</option>
            <option value="voicemail">Voicemail</option>
            <option value="tag">Tag</option>
          </select-input>
          <text-input v-if="!hideEmail" v-model="taskForm.subject" :error="taskForm.errors.subject" class="pr-6 pb-4 w-full" label="Email Subject" />
          <div v-if="hideForVoicemail && hideForTag">
              <label class="form-label">Message:</label>
              <TaskEditor v-model="taskForm.message" :error="taskForm.errors.message" />
          </div>   
          <text-input v-if="!hideForTag" v-model="taskForm.message" :error="taskForm.errors.message" class="pr-6 pb-4 w-full" label="Enter Tags (separaed by commas)" />
          <select-input v-if="!hideForVoicemail" v-model="taskForm.message" :error="taskForm.errors.type" class="pr-6 pb-4 w-full" label="Voicemail Message" @change="handleVoicemailChange">
              <option v-for="voicemail in voicemails" :key="voicemail.id" :value="voicemail.name">{{ voicemail.display }}</option>
          </select-input>
          <div v-if="!hideForVoicemail" class="text-sm text-gray-500 text-center">(Add voicemail recordings on voicemail tab)</div>
          <div v-if="taskForm.errors.message" class="form-error">{{ taskForm.errors.message }}</div>
          <div class="w-full lg:w-auto mb-4 mt-4 text-center">
              <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                <input id="stop_on_reply" v-model="taskForm.stop_on_reply" :true-value="1" :false-value="0" name="stop_on_reply" type="checkbox" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                <label for="stop_on_reply" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" />
              </div>
              <label for="automations">Stop on Reply</label>
          </div>
          <div v-if="hideForTag && hideForVoicemail" class="pb-4 w-full">
            <attachment-uploader :initial-attachment-url="taskForm.attachment" message-type="email" @update:attachmentUrl="updateAttachmentUrl" @update:attachmentName="updateAttachmentName"/>
          </div>
            <div class="tag-input w-full mb-5 min-w-full flex-row">
              <div v-if="hideForVoicemail && hideForTag">
              <div class="flex text-left mt-2 text-m w-full flex-wrap">
                <span class="cursor-pointer tag-input__tag text-sm">Contact Fields</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%first_name%')">first</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%last_name%')">last</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%phone%')">phone</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%email%')">email</span>
              </div>
              <div class="flex tag-input text-left mt-2 pb-2 text-m w-fullmin-w-full">
                <span class="cursor-pointer tag-input__tag text-sm">User Fields</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_first_name%')">first</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_last_name%')">last</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_phone%')">phone</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_email%')">email</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_application_link%')">app link</span>
                <span class="cursor-pointer tag-input__tag bg-indigo-600 text-white text-sm" @click="insertField('%user_appointment_link%')">appointment</span>
              </div>
            </div>
            <div class="flex justify-center items-center mt-4 min-w-full w-full">
              <div>
                <loading-button :loading="taskForm.processing" class="btn-indigo ml-auto" type="submit">Save Task</loading-button>
              </div>
            </div>
          </div>
          <div class="py-10"> </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import TaskEditor from '@/Shared/TaskEditor'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import AttachmentUploader from '@/Shared/AttachmentUploader'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    Datepicker,
    TaskEditor,
    SelectInput,
    TextInput,
    LoadingButton,
    AttachmentUploader,
  },
  props: {
    contact:{
      type: Object,
      default: null,
    },
    button: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      taskForm: router.form({
        contact_id: this.contact.id,
        trigger_time: '',
        delay_minutes: '',
        delay_hours: '',
        delay_days: '',
        delay_months: '',
        stop_on_reply: '',
        type: '',
        subject: '',
        message: '',
        attachment: '',
        attachmentName: '',
        scheduleBy: 'delay',
        delay_from: '',
      }),
      attachmentError: '',
      newButton: this.button,
      voicemails: [],
    }
  },
  computed:{
    hideScheduler() {
      return this.taskForm.scheduleBy == 'delay' ?  false : true
    },
    hideEmail() {
      return this.taskForm.type == 'email' ?  false : true
    },    
    hideForVoicemail() {
      return this.taskForm.type == 'voicemail' ?  false : true
    },
    hideForTag() {
      return this.taskForm.type == 'tag' ?  false : true
    },
  },
  mounted() {
    this.fetchVoicemailRecordings()
  },
  methods:{
    insertField(field) {
      this.taskForm.message = this.taskForm.message + field
    },
    getNumbers:function(start,stop,step = 1){
      return new Array(stop / step).fill(start).map((n,i)=>(i+1)*step);
    },
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    updateMessage: function(messageValue){
      this.taskForm.message=messageValue
    },
    removeAttachment() {
      this.taskForm.attachment=null
      this.taskForm.attachmentName=null
    },
    isImage(url) {
      // Regular expression to match common image extensions
      const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;
      return imageExtensions.test(url);
    },    
    updateAttachmentUrl(url) {
      this.taskForm.attachment = url
    },
    updateAttachmentName(name) {
      this.taskForm.attachmentName = name
    },
    async fetchVoicemailRecordings() {
      try {
        const response = await fetch('/voicemail/getRecordings', {
          headers: {
            'Accept': 'application/json'
          }
        });
        const data = await response.json();
        // Transform the recordings data to match the format expected by the select input
        this.voicemails = data.recordings.map(recording => ({
          id: recording.id,
          name: recording.file_path,
          display: recording.name
        }));
      } catch (error) {
        console.error('Error fetching voicemail recordings:', error);
      }
    },
    handleVoicemailChange(event) {
      // Find the selected voicemail
      const selectedVoicemail = this.voicemails.find(vm => vm.name === event.target.value);
      if (selectedVoicemail) {
        // Store the display name in the subject field
        this.taskForm.subject = selectedVoicemail.display;
      }
    },
    saveTask() {
      if(this.taskForm.type == 'reminder') {
        this.taskForm.message = this.contact.first_name+' '+this.contact.last_name+': '+this.taskForm.message
      }
      if (this.taskForm.type === 'voicemail') {
        // Check if the selected voicemail exists in the recordings list
        const voicemailNames = this.voicemails.map(voicemail => voicemail.name);
        if (!voicemailNames.includes(this.taskForm.message)) {
          alert('Invalid voicemail selection');
          return;
        }
      }
      
      var postTo = '/tasks'
      this.taskForm.post(postTo, {
        onSuccess: () => {
          this.taskForm.reset('delay_from')
          this.taskForm.reset('trigger_time')
          this.taskForm.reset('delay_minutes')
          this.taskForm.reset('delay_hours')
          this.taskForm.reset('delay_days')
          this.taskForm.reset('delay_months')
          this.taskForm.reset('type')
          this.taskForm.reset('subject')
          this.taskForm.reset('message')
          this.taskForm.reset('stop_on_reply')
          this.taskForm.attachment=null
          this.taskForm.attachmentName=null
          this.closeModal()
          // console.log('posted')
        },
      })
    },
  },
}
</script>
<style>
  .tag-input {
    width: 100%;
    /* border: 1px solid #eee; */
    /* font-size: 0.9em; */
    height: 50px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-right:25px;
  }
   .tag-input__tag {
    height: 30px;
    float: left;
    margin-right: 10px;
    /* background-color: #eee; */
    margin-top: 10px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 5px;
  }
  .tag-input__tag > span {
    cursor: pointer;
    opacity: 0.75;
  }
  /* CHECKBOX TOGGLE SWITCH */
  /* @apply rules for documentation, these do not work as inline style */
  .toggle-checkbox:checked {
    right: 0;
    border-color: #68D391;
  }
  .toggle-checkbox:checked + .toggle-label {
    background-color: #68D391;
  }
</style>
